import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import ConversationLog from './ConversationLog';
import C_Sat from './C_Sat';

class ConversationTabSetting extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/reports/conversation";
            var path1 = window.origin + "/platform/projectmgmt/reports/conversation/";
            if (currentPath === path || currentPath === path1) {
                $("#conversation-log-tab").addClass('active');
            } else if (currentPath.includes('/projectmgmt/reports/conversation/c_sat')) {
                $("#c-sat-tab").addClass('active');
            }
            $("#conversation-log-tab,#c-sat-tab")
                .on("click", function () {
                    $("#conversation-log-tab,#c-sat-tab")
                        .removeClass('active');
                    localStorage.setItem("last-used-conversation-settings-sub-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }

    render() {
        return (

            <div id="tabPage">
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="tab-class" style={{ marginLeft: '4px' }}>
                            <ul className="nav nav-tabs border-bottom navCluster" >
                                <Link className="nav-item" to="/projectmgmt/reports/conversation" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="conversation-log-tab" >
                                        Conversation Log
                                    </li>
                                </Link>
                                <Link className="nav-item" to="/projectmgmt/reports/conversation/c_sat" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="c-sat-tab" >
                                        C-SAT
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/reports/conversation/c_sat" component={C_Sat}></Route>
                    <Route path="/projectmgmt/reports/conversation" component={ConversationLog}></Route>
                </Switch>
            </div>

        );
    }
}
export default ConversationTabSetting;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/conversation/ConversationTabSetting.js